import React from 'react';

import checkInIcon from 'stile-shared/assets/images/inside-stiles-lessons/lesson-type-icons/check-in.svg';
import classroomLessonIcon from 'stile-shared/assets/images/inside-stiles-lessons/lesson-type-icons/classroom-lesson.svg';
import culminatingActivityIcon from 'stile-shared/assets/images/inside-stiles-lessons/lesson-type-icons/culminating-activity.svg';
import engineeringChallengeIcon from 'stile-shared/assets/images/inside-stiles-lessons/lesson-type-icons/engineering-challenge.svg';
import formativeAssessmentIcon from 'stile-shared/assets/images/inside-stiles-lessons/lesson-type-icons/formative-assessment.svg';
import glossaryIcon from 'stile-shared/assets/images/inside-stiles-lessons/lesson-type-icons/glossary.svg';
import handsOnActivityIcon from 'stile-shared/assets/images/inside-stiles-lessons/lesson-type-icons/hands-on-activity.svg';
import investigationIcon from 'stile-shared/assets/images/inside-stiles-lessons/lesson-type-icons/investigation.svg';
import keyQuestionIcon from 'stile-shared/assets/images/inside-stiles-lessons/lesson-type-icons/key-question.svg';
import practicalActivityIcon from 'stile-shared/assets/images/inside-stiles-lessons/lesson-type-icons/practical-activity.svg';
import preTestIcon from 'stile-shared/assets/images/inside-stiles-lessons/lesson-type-icons/pre-test.svg';
import questionBoardIcon from 'stile-shared/assets/images/inside-stiles-lessons/lesson-type-icons/question-board.svg';
import researchProjectIcon from 'stile-shared/assets/images/inside-stiles-lessons/lesson-type-icons/research-project.svg';
import testIcon from 'stile-shared/assets/images/inside-stiles-lessons/lesson-type-icons/test.svg';

export enum LessonType {
  FORMATIVE_ASSESSMENT = 'formative-assessment',
  INVESTIGATION = 'investigation',
  CLASSROOM_LESSON = 'classroom-lesson',
  PRACTICAL_ACTIVITY = 'practical-activity',
  HANDS_ON_ACTIVITY = 'hands-on-activity',
  CHECK_IN = 'check-in',
  RESEARCH_PROJECT = 'research-project',
  ENGINEERING_CHALLENGE = 'engineering-challenge',
  GLOSSARY = 'glossary',
  TEST = 'test',
  PRE_TEST = 'pre-test',
  QUESTION_BOARD = 'question-board',
  KEY_QUESTION = 'key-question',
  CULMINATING_ACTIVITY = 'culminating-activity',
}

export type LessonTypeConfig = {
  name: string;
  iconSrc: string;
};

export const LESSON_TYPE_CONFIG: Record<LessonType, LessonTypeConfig> = {
  [LessonType.FORMATIVE_ASSESSMENT]: {
    name: 'Formative assessment',
    iconSrc: formativeAssessmentIcon,
  },
  [LessonType.INVESTIGATION]: {
    name: 'Investigation',
    iconSrc: investigationIcon,
  },
  [LessonType.CLASSROOM_LESSON]: {
    name: 'Classroom lesson',
    iconSrc: classroomLessonIcon,
  },
  [LessonType.PRACTICAL_ACTIVITY]: {
    name: 'Practical activity',
    iconSrc: practicalActivityIcon,
  },
  [LessonType.HANDS_ON_ACTIVITY]: {
    name: 'Hands-on activity',
    iconSrc: handsOnActivityIcon,
  },
  [LessonType.CHECK_IN]: {
    name: 'Check-in',
    iconSrc: checkInIcon,
  },
  [LessonType.RESEARCH_PROJECT]: {
    name: 'Research project',
    iconSrc: researchProjectIcon,
  },
  [LessonType.ENGINEERING_CHALLENGE]: {
    name: 'Engineering challenge',
    iconSrc: engineeringChallengeIcon,
  },
  [LessonType.GLOSSARY]: {
    name: 'Glossary',
    iconSrc: glossaryIcon,
  },
  [LessonType.TEST]: {
    name: 'Test',
    iconSrc: testIcon,
  },
  [LessonType.PRE_TEST]: {
    name: 'Pre-test',
    iconSrc: preTestIcon,
  },
  [LessonType.QUESTION_BOARD]: {
    name: 'Question board',
    iconSrc: questionBoardIcon,
  },
  [LessonType.KEY_QUESTION]: {
    name: 'Key question',
    iconSrc: keyQuestionIcon,
  },
  [LessonType.CULMINATING_ACTIVITY]: {
    name: 'Culminating activity',
    iconSrc: culminatingActivityIcon,
  },
};

export type LessonItemProps = {
  title: string;
  image: React.ReactNode;
  lessonType: LessonType;
  /** Short description shown inline after the lesson type, separated by a bullet. */
  caption?: string;
  previewLink?: string;
  /** Override the default icon for this lesson type. */
  iconSrc?: string;
};
